var _circle, _g, _rect, _path, _circle2, _circle3, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopNavModalImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_892_123759",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 121
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.25,
    cy: 60.25,
    r: 60.25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_892_123759)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.40149,
    y: -9.11328,
    width: 130.308,
    height: 128.907,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.40149,
    y: -9.11328,
    width: 130.308,
    height: 128.907,
    fill: "url(#paint0_linear_892_123759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5546 30.0184L15.0619 67.2508L107.539 67.6011L64.0357 30.0304C62.4628 28.672 60.1334 28.6669 58.5546 30.0184Z",
    fill: "#7595E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.285 46.582L107.889 47.6329",
    stroke: "white",
    strokeWidth: 1.05087,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9792 43.4297H27.3222C25.3876 43.4297 23.8193 44.998 23.8193 46.9326V100.177C23.8193 102.111 25.3876 103.68 27.3222 103.68H95.9792C97.9138 103.68 99.4821 102.111 99.4821 100.177V46.9326C99.4821 44.998 97.9138 43.4297 95.9792 43.4297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9954 54.2852H85.8209",
    stroke: "#CBD8F8",
    strokeWidth: 2.80233,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3452 74.957H74.9615",
    stroke: "#CBD8F8",
    strokeWidth: 2.80233,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3452 61.6484H93.1766",
    stroke: "#9DB5EF",
    strokeWidth: 2.80233,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3452 82.6602H93.8772",
    stroke: "#9DB5EF",
    strokeWidth: 2.80233,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0853 50.0859H32.9268C31.3792 50.0859 30.1245 51.3406 30.1245 52.8883V63.397C30.1245 64.9447 31.3792 66.1993 32.9268 66.1993H43.0853C44.6329 66.1993 45.8876 64.9447 45.8876 63.397V52.8883C45.8876 51.3406 44.633 50.0859 43.0853 50.0859Z",
    stroke: "#CBD8F8",
    strokeWidth: 2.10174,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0853 70.7539H32.9268C31.3792 70.7539 30.1245 72.0086 30.1245 73.5562V84.065C30.1245 85.6126 31.3792 86.8673 32.9268 86.8673H43.0853C44.6329 86.8673 45.8876 85.6126 45.8876 84.065V73.5562C45.8876 72.0086 44.633 70.7539 43.0853 70.7539Z",
    stroke: "#CBD8F8",
    strokeWidth: 2.10174,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0287 58.49L36.5075 62.0393C36.6191 62.3071 36.9893 62.3309 37.1343 62.0796L42.0345 53.5859",
    stroke: "#648AEB",
    strokeWidth: 2.10174,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0287 79.158L36.5075 82.7072C36.6191 82.9751 36.9893 82.9989 37.1343 82.7476L42.0345 74.2539",
    stroke: "#648AEB",
    strokeWidth: 2.10174,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0619 119.093V67.2501L16.4514 66.8332C17.8528 66.4128 19.3081 66.1992 20.7712 66.1992C27.8864 66.1992 34.7153 69.0015 39.7795 73.9995L85.4703 119.093H15.0619Z",
    fill: "#97B1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.539 119.445V67.6017L106.149 67.1848C104.748 66.7644 103.293 66.5508 101.829 66.5508C94.7143 66.5508 87.8854 69.3531 82.8212 74.3511L37.1304 119.445H107.539Z",
    fill: "#97B1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4682 84.8352L15.0619 112.084V123.294C15.0619 125.228 16.6302 126.797 18.5648 126.797H104.036C105.97 126.797 107.539 125.228 107.539 123.294V112.084L63.1323 84.8352C62.0083 84.1454 60.5922 84.1454 59.4682 84.8352Z",
    fill: "#B3C6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1188 40.2812C8.75691 50.79 6.33452 78.5375 14.7119 86.8699C25.9818 98.0792 44.837 86.5196 36.0796 81.9658C22.4263 74.8662 19.4901 107.537 53.5942 107.537",
    stroke: "white",
    strokeWidth: 1.05087,
    strokeLinecap: "round",
    strokeDasharray: "3.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9794 35.0195L97.0302 41.3248",
    stroke: "white",
    strokeWidth: 1.05087,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.386 39.2305L100.952 42.9837",
    stroke: "white",
    strokeWidth: 1.05087,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.2366,
    y: 55.6133,
    width: 20.492,
    height: 20.492,
    rx: 10.246,
    fill: "url(#paint1_linear_892_123759)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.7528 64.3078C95.6046 64.7277 95.1353 64.95 94.7401 64.8018C94.3202 64.6536 94.0979 64.209 94.2461 63.7891C94.5178 63.0234 94.9624 62.3071 95.5552 61.7143C97.7288 59.5654 101.212 59.5654 103.385 61.7143L103.805 62.1589V60.8745C103.805 60.4546 104.176 60.0841 104.595 60.0841C105.04 60.0841 105.386 60.4546 105.386 60.8745V64.0361C105.386 64.4807 105.04 64.8265 104.595 64.8265H101.459C101.014 64.8265 100.668 64.4807 100.668 64.0361C100.668 63.6162 101.014 63.2457 101.459 63.2457H102.694L102.274 62.8258C100.718 61.2944 98.2228 61.2944 96.6667 62.8258C96.2468 63.2704 95.9257 63.7644 95.7528 64.3078ZM94.1226 66.4568C94.1473 66.4321 94.1967 66.4321 94.2214 66.4321C94.2708 66.4321 94.2955 66.4074 94.3449 66.4074H97.5065C97.9264 66.4074 98.2969 66.7779 98.2969 67.1978C98.2969 67.6424 97.9264 67.9882 97.5065 67.9882H96.2468L96.6667 68.4328C98.2228 69.9642 100.718 69.9642 102.274 68.4328C102.694 67.9882 103.015 67.4942 103.188 66.9508C103.336 66.5309 103.805 66.3086 104.2 66.4568C104.62 66.605 104.842 67.0496 104.694 67.4695C104.423 68.2352 103.978 68.9268 103.385 69.5443C101.212 71.6932 97.7288 71.6932 95.5552 69.5443L95.1353 69.0997V70.3594C95.1353 70.804 94.7648 71.1498 94.3449 71.1498C93.9003 71.1498 93.5545 70.804 93.5545 70.3594V67.2225C93.5545 67.1731 93.5545 67.1237 93.5545 67.099C93.5545 67.0496 93.5545 67.0249 93.5792 67.0002C93.6039 66.8767 93.678 66.7532 93.7768 66.6544C93.8756 66.5556 93.9991 66.4815 94.1226 66.4568Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.4825,
    cy: 65.8605,
    r: 12.0353,
    stroke: "url(#paint2_linear_892_123759)",
    strokeWidth: 1.15028
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 59.9958,
    stroke: "#CBD8F8",
    strokeWidth: 0.991667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7228 30.5206L26.4962 26.0547L26.0261 38.7472L34.7228 30.5206Z",
    fill: "#88A6EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0263 38.7503L21.0903 23.4722L60.108 5.84375L26.4964 26.0577L26.0263 38.7503Z",
    fill: "#6E93ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5783 5.60547L42.2446 34.9863L26.4965 26.0545L60.5783 5.60547L21.0905 23.469L9.80823 17.5928L60.5783 5.60547Z",
    fill: "#97B1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_892_123759",
    x1: 63.7526,
    y1: -9.11328,
    x2: 64.1311,
    y2: 86.9696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EDFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_892_123759",
    x1: 99.4826,
    y1: 55.6133,
    x2: 99.4826,
    y2: 76.1053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97B1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E93ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_892_123759",
    x1: 99.4825,
    y1: 53.25,
    x2: 99.4825,
    y2: 78.4709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97B1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E93ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopNavModalImage);
export default __webpack_public_path__ + "static/media/top-nav-modal-image.445af767527f14fc7caaa3b281a85f0d.svg";
export { ForwardRef as ReactComponent };